import React from 'react';
import classNames from 'classnames';

import { ATTENDANCE_SUMMARY_FIELDS } from 'constants/attendanceStatus';

type AttendanceSummaryField = (typeof ATTENDANCE_SUMMARY_FIELDS)[keyof typeof ATTENDANCE_SUMMARY_FIELDS];

interface AttendanceIconProps {
  size?: number;
  color?: string;
}

interface AttendanceSummaryItemProps {
  icon?: React.ComponentType<AttendanceIconProps>;
  size?: number;
  count: number;
  iconColor?: string;
  isVisible?: boolean;
  attendance: string;
  item: AttendanceSummaryField;
}

export function AttendanceSummaryItem(props: Readonly<AttendanceSummaryItemProps>): React.ReactElement | null {
  const { icon: Icon, size = 16, count, iconColor, isVisible = true, attendance, item } = props;

  if (!Icon || !isVisible) {
    return null;
  }

  return (
    <div
      className={classNames('attendance-summary__item d-flex gapx-4 clear-after', {
        'active-attendance': attendance === item,
        'active-attendance--missing':
          item === ATTENDANCE_SUMMARY_FIELDS.MISSING && attendance === ATTENDANCE_SUMMARY_FIELDS.MISSING,
        'hover-enabled': attendance !== item,
      })}
    >
      <div className="icon d-flex">
        <Icon size={size} color={iconColor} />
      </div>
      <div className="count">{count}</div>
    </div>
  );
}
